import { type FC } from "react";
import { IconButton, Link, Stack, TableCell, Tooltip, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import PlaceIcon from "@mui/icons-material/Place";
import type { CustomerSummary } from "../customerSummariesApi";

interface Props {
  client: CustomerSummary;
}

const googleMapsUrl = (city: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${city}, Polska`)}`;

const ClientCity: FC<{ city: string }> = ({ city }) => (
  <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", mt: 0.5 }}>
    <Typography variant="body2">{city}</Typography>
    <Tooltip title="Otwórz w Google Maps">
      <IconButton
        size="small"
        color="primary"
        component="a"
        href={googleMapsUrl(city)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Mapa: ${city}`}
        sx={{ p: 0.25 }}
      >
        <PlaceIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  </Stack>
);

const ClientNameCell: FC<Props> = ({ client }) => (
  <TableCell sx={{ minWidth: 220 }}>
    <Link
      component={RouterLink}
      to={`/customers/${client.id}`}
      variant="body2"
      underline="hover"
      sx={{ fontWeight: 600 }}
    >
      {client.name}
    </Link>
    {client.city && <ClientCity city={client.city} />}
    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5, whiteSpace: "nowrap" }}>
      Opiekun Przezmorze: {client.accountManager?.name ?? "—"}
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ display: "block", whiteSpace: "nowrap" }}>
      Opiekun TravelPay: {client.travelPayAccountManager?.name ?? "—"}
    </Typography>
  </TableCell>
);

export default ClientNameCell;
